import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "@/core/helper/datasource-query-helper";


const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/account/admin/menu`;

export const menuservice = {
    async getAllMenu(loadOptions: any) {
        const params = processLoadOptions(loadOptions);
        return axios.get(`${GATEWAY_URL}/get-menu-list`,{
            params
        }).then((response) => {
            return response.data;
        });
    },
    deleteMenu: async function (id: any)  {
        return axios.delete(`${GATEWAY_URL}/delete-menu`, {
            params: { id: id }
        }).then((response) => {
            return response.data;
        });
    },
    createMenu: async function (params: any) {
        return axios.post(`${GATEWAY_URL}/create-menu`, params)
            .then((response) => {
                return response.data;
            });
    },
    updateMenu: async function (key: any, params: any) {
        return axios.put(`${GATEWAY_URL}/update-menu`, params)
            .then((response) => {
                return response.data;
            });
    },
    getMenuById: async function (id: any) {
        return axios.get(`${GATEWAY_URL}/get-menu-by-id`, {
            params: { id: id }
        }).then((response) => {
            return response.data;
        });
    },
    getMenuTranslate: async function (menuId: any) {
        return axios.get(`${GATEWAY_URL}/get-menu-by-translate`, {
            params: { menuId: menuId }
        }).then((response) => {
            return response.data;
        });
    },
    async lookupMenu(params: any) {
        return axios.get(`${GATEWAY_URL}/lookup-menu`, {
            params
        }).then((response) => {
            return response.data;
        });
    },
}
export default menuservice